import { render, staticRenderFns } from "./GoalCardFooter.vue?vue&type=template&id=6f0c7f34&scoped=true"
import script from "./GoalCardFooter.vue?vue&type=script&lang=js"
export * from "./GoalCardFooter.vue?vue&type=script&lang=js"
import style0 from "./GoalCardFooter.vue?vue&type=style&index=0&id=6f0c7f34&prod&lang=less&scoped=true"
import style1 from "./GoalCardFooter.vue?vue&type=style&index=1&id=6f0c7f34&prod&lang=less"
import style2 from "./GoalCardFooter.vue?vue&type=style&index=2&id=6f0c7f34&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c7f34",
  null
  
)

export default component.exports